import { unityColorTokens } from '../../unityTokens';
import { ChronosphereColor } from './types';

export const unityRed: ChronosphereColor = {
  50: unityColorTokens['--color-red-50'],
  100: unityColorTokens['--color-red-100'],
  150: unityColorTokens['--color-red-200'],
  200: unityColorTokens['--color-red-300'],
  300: unityColorTokens['--color-red-400'],
  400: unityColorTokens['--color-red-500'],
  500: unityColorTokens['--color-red-600'],
  600: unityColorTokens['--color-red-700'],
  700: unityColorTokens['--color-red-800'],
  800: unityColorTokens['--color-red-900'],
  850: unityColorTokens['--color-red-950'],
  900: unityColorTokens['--color-red-1000'],
  950: unityColorTokens['--color-red-1000'],
};

export const red: ChronosphereColor = {
  50: '#FDEDED',
  100: '#FAD1D1',
  150: '#F7B6B6',
  200: '#F49A9A',
  300: '#F07E7E',
  400: '#ED6363',
  500: '#EA4747',
  600: '#C53C3F',
  700: '#A03136',
  800: '#7D272C',
  850: '#5B1E22',
  900: '#350F0F',
  950: '#1F0808',
};
